import React, { useState } from 'react';
import { connect } from 'react-redux'; 
import { downloadConsent, submitAll } from '../actions';
import actions from '../constants/actions';
import FinishedLoginsList from './FinishedLoginsList'; 

const ConsentSuccess = (props) => {

    const [isDownloading, setIsDownloading] = useState(false);

    const downloadClick = async (e) => {
        e.preventDefault();
        setIsDownloading(true);
        try {
            await props.dispatch(downloadConsent(props.consent_guid, props.institution.slug));
        } catch {
            props.dispatch({ type: 'CONSENT_ERROR', data: {slug: props.institution.slug} });
        } finally {
            setIsDownloading(false); // Hide loader
        }
    }

    return (
        <div id="intro">
            <div className="consent-data-wrapper transfer-to-provider">
                <h2 className="form-group text-center">
                    Thank You
                </h2>
                <p>You have successfully given consent to {props.institution.name} to share your account information with us. We will email you a consent receipt and a link to your consumer consent dashboard. You can also download your consent receipt below.</p>
                <div className="form-group">
                    <button
                        className={`form-control btn btn-primary ${props.theme.buttonClass || ''}`}
                        onClick={e => downloadClick(e)}
                        type="button"
                        disabled={isDownloading}
                    >
                        {isDownloading ? "Downloading..." : "Download confirmation of consent"}
                    </button>
                </div>
                {/* Add Finished Logins Block */}
                <FinishedLoginsList finishedLogins={props.finishedLogins} />
                <AddAnotherBank onClick={() => props.dispatch({ type: actions.ADD_ANOTHER_INSTITUTION })} text={props.theme.text.addAnotherInstitutionBtn} />
                <SubmitAll onClick={() => props.dispatch(submitAll())} text={props.theme.text.submitAllBtn} />
            </div>
        </div>
    );
};

const AddAnotherBank = (props) => (
    <div className="form-group">
        <button className="form-control btn btn-primary" onClick={props.onClick} type="button">
            {props.text}
        </button>
    </div>
);

const SubmitAll = (props) => (
    <div className="form-group">
        <button className="form-control btn btn-secondary" onClick={props.onClick} type="button">
            {props.text}
        </button>
    </div>
);

const mapStateToProps = (state) => ({
    theme: state.common.theme,
    finishedLogins: state.finishedLogins
});

export default connect(mapStateToProps)(ConsentSuccess);